const products = [
  { id: 1, cat: 'idols', name: 'Lord Ganesha Brass Idol', price: 2499, mrp: 3999, rating: 4.8, reviews: 342,
    img: 'https://images.unsplash.com/photo-1567591414240-e9c1e838fdc7?w=600&h=600&fit=crop',
    badge: 'Bestseller', desc: 'Handcrafted brass Ganesha idol, 8 inches tall. Perfect for your home mandir.', stock: 45,
    features: ['Hand-polished brass', '8 inches height', 'Anti-tarnish coating', 'Gift-ready packaging'] },
  { id: 2, cat: 'idols', name: 'Lord Shiva Nataraja', price: 3299, mrp: 5499, rating: 4.9, reviews: 218,
    img: 'https://images.unsplash.com/photo-1582126892906-5ba118ebc08c?w=600&h=600&fit=crop',
    badge: 'Premium', desc: 'Exquisite Nataraja in cosmic dance pose, bronze finish.', stock: 22,
    features: ['Solid bronze', '10 inches height', 'Museum-quality', 'Certificate included'] },
  { id: 3, cat: 'idols', name: 'Goddess Lakshmi Gold Idol', price: 4599, mrp: 6999, rating: 4.7, reviews: 156,
    img: 'https://images.unsplash.com/photo-1621416894569-0f39ed31d247?w=600&h=600&fit=crop',
    badge: 'New', desc: 'Gold-plated Lakshmi idol radiating prosperity and abundance.', stock: 18,
    features: ['24K gold plating', '6 inches height', 'Lotus pedestal', 'Velvet base'] },
  { id: 4, cat: 'idols', name: 'Lord Krishna with Flute', price: 1899, mrp: 2999, rating: 4.6, reviews: 289,
    img: 'https://images.unsplash.com/photo-1633534882687-3e4957f3d4e2?w=600&h=600&fit=crop',
    desc: 'Beautiful Krishna idol in tribhanga pose.', stock: 60,
    features: ['Detailed craftsmanship', '7 inches', 'Marble finish', 'Peacock feather crown'] },
  { id: 5, cat: 'rudraksha', name: '5 Mukhi Rudraksha Mala', price: 1299, mrp: 2499, rating: 4.9, reviews: 567,
    img: 'https://images.unsplash.com/photo-1611516491426-03025e6043c8?w=600&h=600&fit=crop',
    badge: 'Bestseller', desc: 'Certified 5 Mukhi Rudraksha, 108+1 beads mala.', stock: 120,
    features: ['Lab-certified', '108+1 count', 'Nepal origin', 'Silk thread'] },
  { id: 6, cat: 'rudraksha', name: '1 Mukhi Rudraksha', price: 15999, mrp: 21000, rating: 5.0, reviews: 89,
    img: 'https://images.unsplash.com/photo-1599707367790-a54bafa66353?w=600&h=600&fit=crop',
    badge: 'Rare', desc: 'Extremely rare single-face Rudraksha with certificate.', stock: 3,
    features: ['One-of-a-kind', 'X-ray verified', 'Gold cap', 'Lifetime certificate'] },
  { id: 7, cat: 'rudraksha', name: 'Gauri Shankar Rudraksha', price: 5499, mrp: 7999, rating: 4.8, reviews: 134,
    img: 'https://images.unsplash.com/photo-1602836831852-ef68e5290b18?w=600&h=600&fit=crop',
    desc: 'Natural twin Rudraksha for love & harmony.', stock: 15,
    features: ['Natural twin', 'Silver cap', 'Certified', 'Energized in Kashi'] },
  { id: 8, cat: 'karungali', name: 'Karungali Malai', price: 899, mrp: 1499, rating: 4.7, reviews: 423,
    img: 'https://images.unsplash.com/photo-1515377905703-c4788e51af15?w=600&h=600&fit=crop',
    badge: 'Popular', desc: 'Authentic ebony wood mala, 108 beads.', stock: 200,
    features: ['Pure ebony wood', '108 beads', 'Hand-polished', 'Cotton pouch'] },
  { id: 9, cat: 'karungali', name: 'Karungali Lingam', price: 1599, mrp: 2499, rating: 4.8, reviews: 198,
    img: 'https://images.unsplash.com/photo-1609710228159-0fa9bd7c0827?w=600&h=600&fit=crop',
    desc: 'Hand-carved Shiva Lingam from aged Karungali wood.', stock: 35,
    features: ['Single-piece carving', '4 inches', 'Aged wood', 'Brass base'] },
  { id: 10, cat: 'karungali', name: 'Karungali Bracelet', price: 599, mrp: 999, rating: 4.6, reviews: 312,
    img: 'https://images.unsplash.com/photo-1573408301185-9146fe634ad0?w=600&h=600&fit=crop',
    desc: 'Protective Karungali bead bracelet.', stock: 150,
    features: ['Elastic fit', '8mm beads', 'Unisex design', 'Handcrafted'] },
  { id: 11, cat: 'jewellery', name: 'Om Pendant Gold Plated', price: 1199, mrp: 1999, rating: 4.8, reviews: 445,
    img: 'https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?w=600&h=600&fit=crop',
    badge: 'Trending', desc: '18K gold-plated Om pendant with chain.', stock: 80,
    features: ['18K gold plating', '22" chain', 'Hypoallergenic', 'Gift box'] },
  { id: 12, cat: 'jewellery', name: 'Trishul Silver Ring', price: 799, mrp: 1299, rating: 4.7, reviews: 267,
    img: 'https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=600&h=600&fit=crop',
    desc: 'Sterling silver Trishul ring, adjustable.', stock: 95,
    features: ['925 Silver', 'Adjustable', 'Oxidized finish', 'Handmade'] },
  { id: 13, cat: 'jewellery', name: 'Temple Necklace Set', price: 3499, mrp: 5999, rating: 4.9, reviews: 178,
    img: 'https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?w=600&h=600&fit=crop',
    badge: 'Premium', desc: 'Traditional South Indian temple jewellery set.', stock: 25,
    features: ['Temple design', 'Matt gold finish', 'Stone studded', 'Necklace + Earrings'] },
  { id: 14, cat: 'japamala', name: 'Tulsi Japa Mala 108', price: 499, mrp: 899, rating: 4.8, reviews: 678,
    img: 'https://images.unsplash.com/photo-1590736969955-71cc94901144?w=600&h=600&fit=crop',
    badge: 'Bestseller', desc: 'Sacred Tulsi wood 108+1 beads japa mala.', stock: 250,
    features: ['Holy Tulsi wood', '108+1 beads', 'Vrindavan blessed', 'Mala bag'] },
  { id: 15, cat: 'japamala', name: 'Sandalwood Mala Premium', price: 1899, mrp: 2999, rating: 4.9, reviews: 234,
    img: 'https://images.unsplash.com/photo-1602173574767-37ac01994b2a?w=600&h=600&fit=crop',
    desc: 'Mysore sandalwood 108 bead mala.', stock: 55,
    features: ['Mysore sandalwood', 'Natural fragrance', 'Hand-knotted', 'Silk pouch'] },
  { id: 16, cat: 'japamala', name: 'Crystal Sphatik Mala', price: 2499, mrp: 3999, rating: 4.7, reviews: 156,
    img: 'https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=600&h=600&fit=crop',
    desc: 'Natural crystal quartz sphatik japa mala.', stock: 30,
    features: ['Natural quartz', 'Transparent', '108 count', 'Energy amplifier'] },
  { id: 17, cat: 'astrostone', name: 'Blue Sapphire (Neelam)', price: 8999, mrp: 12999, rating: 4.9, reviews: 98,
    img: 'https://images.unsplash.com/photo-1599707367790-a54bafa66353?w=600&h=600&fit=crop',
    badge: 'Certified', desc: 'Natural Blue Sapphire, 3.5 carat.', stock: 8,
    features: ['3.5 carat', 'Lab certified', 'Sri Lankan origin', 'Ring setting available'] },
  { id: 18, cat: 'astrostone', name: 'Ruby (Manik) Stone', price: 6499, mrp: 9999, rating: 4.8, reviews: 124,
    img: 'https://images.unsplash.com/photo-1551122087-f99a4ade7874?w=600&h=600&fit=crop',
    desc: 'Natural Ruby gemstone, 2.8 carat.', stock: 12,
    features: ['2.8 carat', 'Blood-red hue', 'Burmese origin', 'GIA certified'] },
  { id: 19, cat: 'astrostone', name: 'Emerald (Panna) Ring', price: 7999, mrp: 11999, rating: 4.7, reviews: 87,
    img: 'https://images.unsplash.com/photo-1583937443489-1fbb4ef5eb04?w=600&h=600&fit=crop',
    desc: 'Colombian Emerald in silver ring, 3 carat.', stock: 10,
    features: ['3 carat', 'Colombian origin', '925 silver ring', 'Astrological consult'] },
  { id: 20, cat: 'pooja', name: 'Complete Pooja Thali Set', price: 1499, mrp: 2499, rating: 4.8, reviews: 534,
    img: 'https://images.unsplash.com/photo-1606293926075-69a00dbfde81?w=600&h=600&fit=crop',
    badge: 'Bestseller', desc: 'Brass pooja thali with all essentials, 12-piece.', stock: 85,
    features: ['12-piece set', 'Pure brass', 'Engraved design', 'Complete starter kit'] },
  { id: 21, cat: 'pooja', name: 'Brass Diya Set (5 pcs)', price: 699, mrp: 1199, rating: 4.7, reviews: 389,
    img: 'https://images.unsplash.com/photo-1605710955498-c3fb1a24a1bd?w=600&h=600&fit=crop',
    desc: 'Traditional brass oil lamp diya set.', stock: 130,
    features: ['5 different sizes', 'Pure brass', 'Hand-engraved', 'Cotton wicks'] },
  { id: 22, cat: 'pooja', name: 'Camphor & Incense Kit', price: 399, mrp: 699, rating: 4.6, reviews: 456,
    img: 'https://images.unsplash.com/photo-1589308454676-21aacc15c766?w=600&h=600&fit=crop',
    desc: 'Pure camphor + premium agarbatti combo.', stock: 300,
    features: ['Pure camphor', '6 fragrances', '3-month supply', 'Brass holder'] },
  { id: 23, cat: 'pooja', name: 'Panchdhatu Kalash', price: 2999, mrp: 4999, rating: 4.9, reviews: 112,
    img: 'https://images.unsplash.com/photo-1604608672516-f1b9a4d5e4c1?w=600&h=600&fit=crop',
    badge: 'Premium', desc: 'Five-metal sacred kalash for ceremonies.', stock: 20,
    features: ['5 sacred metals', '8 inches', 'Vedic specs', 'Ceremony ready'] },
  { id: 24, cat: 'jewellery', name: 'Rudraksha Gold Bracelet', price: 2199, mrp: 3499, rating: 4.8, reviews: 203,
    img: 'https://images.unsplash.com/photo-1611591437281-460bfbe1220a?w=600&h=600&fit=crop',
    desc: 'Gold-plated bracelet with genuine Rudraksha.', stock: 40,
    features: ['Genuine Rudraksha', 'Gold plated links', 'Adjustable clasp', 'Unisex'] },
];

export default products;

// Named exports so files can do: import { products, categories } from '../../data/products'
export { products };
export { categories } from './categories';

// Helper functions used across pages
export const searchProducts = (query = '') => {
  const q = query.toLowerCase().trim();
  if (!q) return products;
  return products.filter(p =>
    p.name.toLowerCase().includes(q) ||
    (p.desc || '').toLowerCase().includes(q) ||
    (p.category || '').toLowerCase().includes(q)
  );
};

export const getProductsByCategory = (categoryId) => {
  if (!categoryId) return products;
  return products.filter(p =>
    p.category_id === categoryId ||
    p.categoryId  === categoryId ||
    p.category    === categoryId
  );
};

export const getFeaturedProducts = (limit = 8) =>
  products.filter(p => p.featured).slice(0, limit);

export const getProductById = (id) =>
  products.find(p => String(p.id) === String(id));
